var _themes;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled, { css, keyframes } from 'styled-components';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import FocusLock from 'react-focus-lock';
import Spinner from '../Spinner';
import ControlButton from '../ControlButton';
import { getClassName } from '../utils/get-class-name';
import TscButtonType from '../constants/TscButtonType';
var structure = {
  headerHeight: '3rem',
  width: '28rem',
  borderRadius: '6px'
};
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  window: {
    background: tscStyles.color.ui.dawn.light,
    color: tscStyles.color.text.mediumDark
  },
  header: {
    background: tscStyles.color.ui.dawn.medium,
    color: tscStyles.color.text.mediumDark
  }
}), _defineProperty(_themes, TscThemeName.dusk, {
  window: {
    background: tscStyles.color.ui.dusk.medium,
    color: tscStyles.color.text.light
  },
  header: {
    background: tscStyles.color.ui.dusk.mediumDark,
    color: tscStyles.color.text.lightMedium
  }
}), _themes);
var flyinAnimation = keyframes(["0%{opacity:0;transform:translateY(25%)}100%{opacity:1;:translateY(0)}"]);
var fadein = keyframes(["from{opacity:0;}to{opacity:1;}"]);
var Container = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "MobileContextMenu__Container"
})(["visibility:", ";position:fixed;display:block;top:0;right:0;bottom:0;left:0;color:", ";z-index:", ";text-align:center;overflow-y:auto;opacity:", ";background:rgba(99,106,112,0.5);animation:", " 300ms ease;animation-fill-mode:forwards;.focus-guard{position:absolute;bottom:0;left:0;right:0;overflow:hidden;padding:0 1rem;}"], function (props) {
  return props.visible ? 'visible' : 'hidden';
}, tscStyles.color.text.mediumDark, function (props) {
  return props.zIndex;
}, function (props) {
  return props.visible ? '1' : '0';
}, fadein);
var Modal = styled.div.withConfig({
  displayName: "MobileContextMenu__Modal"
})(["width:100%;height:", ";max-width:", ";margin-top:auto;margin-right:auto;margin-bottom:0;margin-left:auto;background:", ";color:", ";border-radius:", " ", " 0 0;box-shadow:0 0 1rem rgba(0,0,0,.2);animation:", ";position:relative;bottom:0;"], function (props) {
  return props.height;
}, function (props) {
  return props.maxWidth;
}, function (props) {
  return themes[props.themeName].window.background;
}, function (props) {
  return themes[props.themeName].window.color;
}, structure.borderRadius, structure.borderRadius, function (props) {
  return props.visible && css(["", " 300ms  ease;"], flyinAnimation);
});
var CloseButtonContainer = styled.div.withConfig({
  displayName: "MobileContextMenu__CloseButtonContainer"
})(["padding:0.5rem 3rem 1.5rem 3rem;"]);
var Header = styled.div.withConfig({
  displayName: "MobileContextMenu__Header"
})(["padding:0 1rem;height:", ";display:flex;align-items:center;justify-content:center;color:", ";background:", ";flex-shrink:0;border-radius:", " ", " 0 0;z-index:", ";"], structure.headerHeight, function (props) {
  return themes[props.themeName].header.color;
}, function (props) {
  return themes[props.themeName].header.background;
}, structure.borderRadius, structure.borderRadius, function (props) {
  return props.zIndex;
});
var Body = styled.div.withConfig({
  displayName: "MobileContextMenu__Body"
})(["line-height:1.4;position:relative;& li{color:", ";background:", ";&:hover{background-color:", ";}&:active{border-color:currentColor;}}"], function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.text.light : tscStyles.color.text.mediumDark;
}, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.ui.dusk.medium : tscStyles.color.global.white;
}, function (props) {
  return props.themeName === TscThemeName.dawn ? tscStyles.color.ui.dawn.medium : tscStyles.color.ui.dusk.lightMedium;
});
var Title = styled.h2.withConfig({
  displayName: "MobileContextMenu__Title"
})(["padding:0;margin:0;font-size:1.125rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:600;"]);
var LoadingSpinner = styled.div.withConfig({
  displayName: "MobileContextMenu__LoadingSpinner"
})(["position:absolute;display:flex;align-items:center;top:0;bottom:0;left:0;right:0;z-index:3;opacity:.9;background:", ";"], function (props) {
  return props.themeName === TscThemeName.dawn ? tscStyles.color.ui.dawn.lightMedium : tscStyles.color.ui.dusk.dark;
});
var defaultProps = {
  closeContent: 'Close',
  enableFocusTrap: true,
  headerVisible: true,
  height: 'auto',
  isLoading: false,
  maxWidth: '31.25rem',
  themeName: TscThemeName.dawn,
  title: 'Modal Title',
  visible: true,
  zIndex: 10
};

var MobileContextMenu = function MobileContextMenu(props) {
  var _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
      children = _defaultProps$props.children,
      className = _defaultProps$props.className,
      closeContent = _defaultProps$props.closeContent,
      enableFocusTrap = _defaultProps$props.enableFocusTrap,
      headerVisible = _defaultProps$props.headerVisible,
      height = _defaultProps$props.height,
      isLoading = _defaultProps$props.isLoading,
      maxWidth = _defaultProps$props.maxWidth,
      onClose = _defaultProps$props.onClose,
      testId = _defaultProps$props.testId,
      themeName = _defaultProps$props.themeName,
      title = _defaultProps$props.title,
      visible = _defaultProps$props.visible,
      zIndex = _defaultProps$props.zIndex; // overlay the defaultProps and passed in props in logical order and spread to constant values


  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      clickStartedInContainer = _React$useState2[0],
      setClickStartedInContainer = _React$useState2[1];

  var stopPropagation = function stopPropagation(e) {
    e.stopPropagation();
  };

  var onContainerMouseDown = function onContainerMouseDown() {
    setClickStartedInContainer(true);
  };

  var onContainerMouseUp = function onContainerMouseUp(e) {
    if (clickStartedInContainer && onClose) {
      onClose(e);
    }

    setClickStartedInContainer(false);
  };

  var focusTrapActive = enableFocusTrap && visible;
  var HeaderElement = null;

  if (headerVisible) {
    HeaderElement = _jsx(Header, {
      className: getClassName(className, 'header'),
      themeName: themeName,
      zIndex: zIndex,
      children: _jsx(Title, {
        className: getClassName(className, 'title'),
        children: title
      })
    });
  }

  return _jsx(Container, {
    className: getClassName(className, null, 'container'),
    visible: visible,
    testId: testId,
    zIndex: zIndex,
    onMouseDown: onContainerMouseDown,
    onMouseUp: onContainerMouseUp,
    children: _jsx(FocusLock, {
      className: getClassName(className, 'focus-lock', 'focus-guard'),
      disabled: !focusTrapActive,
      children: _jsxs(Modal, {
        className: getClassName(className, 'modal'),
        themeName: themeName,
        visible: visible,
        maxWidth: maxWidth,
        height: height,
        onClick: stopPropagation,
        onMouseDown: stopPropagation,
        onMouseUp: stopPropagation,
        children: [HeaderElement, _jsxs(Body, {
          className: getClassName(className, 'body'),
          themeName: themeName,
          children: [children, _jsx(CloseButtonContainer, {
            className: getClassName(className, 'close-button-container'),
            children: _jsx(ControlButton, {
              label: closeContent,
              buttonType: TscButtonType.secondary,
              themeName: themeName,
              onClick: function onClick(e) {
                return onClose && onClose(e);
              },
              isFullWidth: true,
              className: className
            })
          }), isLoading && _jsx(LoadingSpinner, {
            className: getClassName(className, 'loading-spinner'),
            themeName: themeName,
            children: _jsx(Spinner, {
              className: className,
              themeName: themeName
            })
          })]
        })]
      })
    })
  });
};

MobileContextMenu.defaultProps = defaultProps;
var MobileContextMenuTest = {
  Container: Container,
  Modal: Modal,
  Header: Header,
  Body: Body,
  Title: Title,
  LoadingSpinner: LoadingSpinner
};
export { MobileContextMenu, MobileContextMenuTest };
export default MobileContextMenu;